import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TabTitle from "../components/TabTitle";
import { loginUser } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { useNotification } from "../hooks/useNotification";
import Logo from "../assets/logo2.png";
import "./Login.css";

const Login = () => {
  const { login } = useAuth();
  const { notifyLogin, notifyError } = useNotification();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = await loginUser({ email, password });
      login(data.token);

      // ✅ TOAST + SOM de login bem-sucedido + Nome do Usuario
      notifyLogin(`Bem-vindo(a) ao ACADE, ${data.user?.email || email}!`);
      navigate("/dashboard");
    } catch (error) {
      const errorMsg = error.message || "Erro ao fazer login.";
      setError(errorMsg);

      // ❌ TOAST + SOM de erro
      notifyError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TabTitle activeTab="Login" />

      {/* Logo flutuante */}
      <div className="floating-logo">
        <img src={Logo} alt="Logo ACADE" />
       <div className="smoke"></div>
      </div>


      <div className="login-container">
        <header className="login-header">
          <h2>Login ACADE</h2>
        </header>

        <div className="login-box">
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="email">E-mail:</label>
              <input
                type="email"
                id="email"
                placeholder="Digite seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="senha">Senha:</label>
              <input
                type="password"
                id="senha"
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? "Carregando..." : "INICIAR SESSÃO"}
            </button>
          </form>

          <div className="register-link">
            <p>
              Ainda não tem uma conta? <a href="/register">Crie uma agora!</a>
            </p>
          </div>
        </div>

        <footer className="footer">
          <p>© 2024-2025 Desenvolvido por Chaúca Creative, Lda. Todos os direitos reservados.</p>
        </footer>
      </div>
    </>
  );
};

export default Login;
